const Form021EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInfo: "Application Information",
        confirmation: "Confirmation",
    },
    notes: {
        // tips1: "1. <b>Individual schools conducting recruitment exercise on their own</b> should send the completed application form together with supporting documents to the respective <b>SSDO</b> for approval.",
        // tips2: "2. For <b>groups of schools conducting a collaborative recruitment exercise</b>, the School Supervisor/Principal in charge of the recruitment (i.e. the applicant school) should send the completed application form together with supporting documents to <b>Education Officer (NET Administration)[EO(NET_Admin)], 11/F,</b> Room 1110, Wu Chung House, 213 Queen’s Road East, Wan Chai, HK for approval.",
        // tips3: "3. Please attach <b>documentary evidence</b> for the recruitment expenses such as invoice/receipt for advertisements placed in newspapers, used air tickets for interview board members, telephone bills, invoice/receipt from recruitment consultant/agent and the HKCAAVQ, etc.",
        tips1: "Reference Materials:",
        tips2: `"Information sheet on Recruitment Subsidy"`,
        tips3: "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/Information_Recruitment Subsidy.pdf",
    },
    label: {
        select: "Select whichever is appropriate",
        statement:
            "I have read, understand and agree to the above terms and conditions",
        statementHeader: "Statement",
        notesTitle: "Notes",
        recruitmentTitle: "I hereby apply for the recruitment subsidy for ",
        partA: "A. For Schools which have successfully recruited NETs:",
        partB: "B. For schools which are unable to recruit a suitable NET for:",
        // recruitment1:
        //     "1. I hereby apply for the recruitment subsidy for recruiting",
        recruitment1: " NET(s) has/have been successfully recruited for",
        ssdo: "SSDO",
        school: "School",
        dutyName: "Name of NET recruited and having reported for duty",
        place: "Recruited locally or from overseas (please state the place/country)",
        contractDate: "Contract commencement date",
        num1: "1. ",
        num2: "2. ",
        certify: "I certify that -",
        certify1: "NET(s) recruited by our school has/have reported for duty.",
        certify2:
            "the NETs shown on the list at (1) above have reported for duty.",
        attachment:
            "Please upload a copy of the appointment form of the NET recruited:",
        total: "3. The total amount claimed is $",
        partB1: "1. I hereby apply for the recruitment subsidy for conducting a recruitment exercise.",
        total1: "2. The total amount claimed is $",
        supervisorSign: "Signature of Supervisor/Principal",
        supervisorName: "Name of Supervisor/Principal",
        supervisorPrincipal: "Name of ",
        schoolName: "Name of Applicant School",
        schoolAddress: "School Address",
        telNo: "Tel No.",
        faxNo: "Fax No.",
        date: "Date",
        attn: "Attn",
        recruitment:
            "I certify that the amount claimed above is solely for the purpose of NET recruitment.",
        document:
            "Please upload documentary evidence for the recruitment expenses such as invoice/receipt for advertisements placed in newspapers, used air tickets for interview board members, telephone bills, invoice/receipt from recruitment consultant/agent and the HKCAAVQ, etc:",
        specify: "Please specify",
        remarkTips: `If "our school" is selected, the application will be submitted to respective SSDO. \nIf "a group of schools" is selected, the application will be submitted to the NET Admin Team.`,
        schoolOptionTips: {
            1: "Individual schools conducting recruitment exercise on their own should send the completed application form together with supporting documents to the respective SSDO for approval.",
            2: `For groups of schools conducting a collaborative recruitment exercise, the School Supervisor/Principal in charge of the recruitment (i.e. the applicant school) should send the completed application form together with supporting documents to Education Officer (NET Administration)[EO(NET_Admin)], Room {{address}} for approval.`,
        },
    },

    option: {
        schoolOption: {
            1: "our school",
            2: "a group of schools conducting a collaborative recruitment exercise",
        },
        schoolPartOption: {
            1: "our school.",
            2: "the schools listed below.",
        },
        schoolPartBOption: {
            1: "our school.",
            2: "a group of schools.",
        },
        supervisorOption: {
            supervisor: "Supervisor",
            schoolHead: "Principal",
        },
        attnOption: {
            admin: "EO(NET Admin)",
            ssdo: "SSDO:",
        },
        optionHidden:
            "(This option is not delegated to current user. please contact your school head for help.)",
    },
    errorMsg: {
        faxDigit: "Fax number must be exactly 8 digits",
        moreThenNets: "This field must not be larger than the NET(s) field.",
        netsLength: "This field must have {{max}} items",
    },
};
export default Form021EN;
